import { RouterProvider } from "react-router-dom";
import { ConfigProvider } from "antd";
import { vaultTheme } from "@/config/antd-theme";
import ApiSetup from "@/components/providers/ApiSetup";
import { router } from "@/router";

export default function App() {
  return (
    <ApiSetup>
      <ConfigProvider theme={vaultTheme}>
        <RouterProvider router={router} />
      </ConfigProvider>
    </ApiSetup>
  );
}
